export default function TimerChip({ timeLeft, formatTime, className = "", compact = false }) {
  if (timeLeft === null) return null;
  const danger = timeLeft <= 60 * 5;
  const warn = timeLeft > 60 * 5 && timeLeft <= 10 * 60;
  const glow = danger ? "shadow-[0_0_20px_rgba(244,63,94,0.45)]" : warn ? "shadow-[0_0_18px_rgba(245,158,11,0.35)]" : "shadow-[0_0_18px_rgba(99,102,241,0.35)]";
  const ring = danger ? "border-rose-400/70" : warn ? "border-amber-300/60" : "border-indigo-400/50";
  const bg = danger ? "bg-rose-500/15" : warn ? "bg-amber-500/15" : "bg-indigo-500/15";
  const text = danger ? "text-rose-100" : warn ? "text-amber-100" : "text-indigo-100";
  return (
    <div className={["inline-flex items-center gap-3 rounded-2xl border backdrop-blur", ring, bg, glow, compact ? "px-3 py-2" : "px-4 py-3", className].join(" ")} role="status" aria-label="Temps restant">
      <span className="text-lg leading-none">⏱️</span>
      <div className="leading-tight">
        <div className="text-[10px] uppercase tracking-[0.22em] text-white/70">Temps restant</div>
        <div className={["font-mono font-extrabold", compact ? "text-base" : "text-2xl", text, danger ? "animate-pulse" : ""].join(" ")}>{formatTime(timeLeft)}</div>
      </div>
      {danger && <span className="ml-1 text-[10px] font-semibold text-rose-200/90 uppercase tracking-wider">URGENT</span>}
    </div>
  );
}